import { ResourceModel, Field } from '@smartsoftware/reflex-core';
import { DexResourceModel } from '../abstracts/dexResource.model';

export class SuccessAccountPermissionNode extends DexResourceModel {

    @Field(String)
    public permissionNode_uuid: string = "";
    @Field(String)
    public successAccount_uuid: string = "";
    @Field(Date)
	public createdAt: Date = new Date();
	@Field(Date)
	public updatedAt: Date = new Date();
    @Field(Date)
	public deletedAt: Date | null = null;
    constructor(data?: any) {
        super();
        this.mapData(data);
    }
    
    public get data(): any {
        let json = super.data;

        return json;
    }


}
